import axios from "axios";

import { useState } from "react";

export function useStudentChoiceCourseSelection(documentId?: number) {
  const [selectedCourseIds, setSelectedCourseIds] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = (courseId: string, checked: boolean) => {
    setSelectedCourseIds((prev) =>
      checked ? [...prev, courseId] : prev.filter((id) => id !== courseId)
    );
  };

  const submitSelectedCourses = async () => {
    setLoading(true);
    try {
      if (selectedCourseIds.length > 0) {
        const csrfToken = document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content");
        const response = await axios.post(
          `/documents/${documentId}/add_as_student_choice_cases`,
          { courseIds: selectedCourseIds },
          csrfToken ? { headers: { "X-CSRF-Token": csrfToken } } : undefined
        );

        if (response.status === 201 || response.status === 200) {
          console.log(
            "Successfully added as student-choice case to selected course(s)."
          );
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    selectedCourseIds,
    setSelectedCourseIds,
    loading,
    handleCheckboxChange,
    submitSelectedCourses,
  };
}
